import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { createStructuredSelector } from 'reselect'
import styled from 'styled-components'
import get from 'lodash/get'
import set from 'lodash/set'
import find from 'lodash/find'
import { Container, Row, Col } from 'reactstrap'
import moment from '../../lib/moment.js'
import { css } from '@emotion/core'
import { BeatLoader } from 'react-spinners'
import {
  modalAction,
  authAction,
  employeeAction,
  subcontractCostAction,
} from './../../actions'
import {
  modalSelector,
  authSelector,
  employeeSelector,
  subcontractCostSelector,
} from './../../selectors'
import {
  SearchBar,
  SubcontractCostTable,
  EditSubcontractCost,
} from '../../components/subcontract-cost'
import * as subcontractHelper from '../../components/subcontract-cost/helpers/subcontract-cost'
import { generateButton } from '../../components/subcontract-cost/helpers/button'
import CustomModalMessage from '../../components/modal-message'
import withLayout from '../../helpers/withLayout'

class SubcontractCostPage extends React.Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    const access_token = localStorage.getItem('access_token')
    const tempState = prevState
    if (get(nextProps, 'getSubcontractCostData.subcontractCostMasters')
    && prevState.subcontracts) {
      set(tempState, 'subContractCosts',
        subcontractHelper.createSubcontractCostList(get(nextProps, 'getSubcontractCostData.subcontractCostMasters'), prevState.subcontracts))
      nextProps.resetGetSubcontractCost()
    }
    if (get(nextProps, 'getEmployeeData')) {
      set(tempState, 'subcontracts', subcontractHelper.createSubcontractList(get(nextProps, 'getEmployeeData')))
      nextProps.resetGetEmployee()
    }
    if (get(nextProps, 'createSubcontractCostData.createdSubcontractCostMaster')) {
      const subcontractCost = get(nextProps, 'createSubcontractCostData')
      if (get(subcontractCost, 'status') === 200) {
        nextProps.showConfirm('createCost', get(subcontractCost, 'status'), get(subcontractCost, 'message'))
        nextProps.getSubcontractCost(access_token)
      } else {
        nextProps.showConfirm('createCost', 'Error', get(subcontractCost, 'message'))
      }
      nextProps.resetCreateSubcontractCost()
    }
    if (get(nextProps, 'editSubcontractCostData.updatedSubcontractCostMaster')) {
      const updatedCost = get(nextProps, 'editSubcontractCostData')
      if (get(updatedCost, 'status') === 200) {
        nextProps.showConfirm('updateCost', get(updatedCost, 'status'), get(updatedCost, 'message'))
        nextProps.getSubcontractCost(access_token)
      } else {
        nextProps.showConfirm('updateCost', 'Error', get(updatedCost, 'message'))
      }
      nextProps.resetEditSubcontractCost()
    }
    if (get(nextProps, 'exportSubcontractCostData')) {
      window.open(get(nextProps, 'exportSubcontractCostData'))
      nextProps.resetExportSubcontractCost()
    }
    return tempState
  }

  state={
    rowID: '',
    isSpan: false,
    isEdit: false,
    searchSubcontract: '',
    subContractCosts: [],
    user: '',
    cost: 0,
    price: 0,
    start_date: moment(),
    end_date: moment(),
  }

  componentDidMount() {
    const access_token = localStorage.getItem('access_token')
    this.props.getAuth(access_token)
    this.props.getEmployee(access_token)
    this.props.getSubcontractCost(access_token)
  }

  handleSearch = (e) => {
    this.setState({ searchSubcontract: e })
  }

  clickRow = (rowID, subcon) => {
    const user = find(this.state.subcontracts, {
      value: subcon.user_id,
    })
    this.setState({
      isEdit: false,
      isSpan: true,
      rowID,
      subcon,
      user: get(user, 'label', '-'),
      cost: get(subcon, 'cost', 0),
      price: get(subcon, 'price', 0),
      start_date: get(subcon, 'start_date') ? moment(subcon.start_date) : moment(),
      end_date: get(subcon, 'end_date') ? moment(subcon.end_date) : moment(),
    })
  }

  clickEdit = (type) => {
    if (type === 'cancel') {
      this.setState({
        cost: this.state.subcon.cost,
        price: this.state.subcon.price,
        start_date: moment(this.state.subcon.start_date),
        end_date: moment(this.state.subcon.end_date),
      })
    }
    this.setState({ isEdit: !this.state.isEdit })
  }

  editSubcontractCost = () => {
    const payload = {}
    payload.user_id = this.state.subcon.user_id
    payload.cost = this.state.cost
    payload.price = this.state.price
    payload.start_date = this.state.start_date
    payload.end_date = this.state.end_date
    this.props.editSubcontractCost(this.state.subcon._id, payload, localStorage.getItem('access_token'))
    this.setState({ isEdit: !this.state.isEdit })
  }

  discardCost = (type) => {
    if (type === 'discard') {
      this.setState({
        isEdit: !this.state.isEdit,
        isSpan: !this.state.isSpan,
        rowID: '',
      })
    }
    this.props.hideConfirm('discardCost')
  }

  handleEditInput = (e, type) => {
    if (type === 'start_date') this.setState({ start_date: e })
    else if (type === 'end_date') this.setState({ end_date: e })
    else this.setState({ [e.target.name]: e.target.value })
  }

  handleClose = () => {
    if (this.state.isEdit) {
      this.props.showConfirm('discardCost', 'Discard', 'Are you sure you want to discard all changes ?')
    } else {
      this.setState({
        isSpan: !this.state.isSpan,
        rowID: '',
      })
    }
  }

  selectButton = (confirmStatus, confirmType) => {
    if (confirmStatus === 200) return generateButton('success', () => this.props.hideConfirm(confirmType))
    else if (confirmStatus === 'Discard') return generateButton('discard', (type) => this.discardCost(type))
    else if (confirmStatus === 'Error') return generateButton('error', () => this.props.hideConfirm(confirmType))
    return null
  }

  filterSubcontract = () => {
    const search = this.state.searchSubcontract.toLowerCase()
    let subContractCosts = this.state.subContractCosts
    if (search !== '') {
      subContractCosts = subContractCosts.filter((cost) => {
        return cost.emp_code.toLowerCase().includes(search)
        || cost.name.toLowerCase().includes(search)
      })
    }
    return subContractCosts
  }

  render() {
    const isFetching = get(this.props, 'getIsFetchingSubcon')
    || get(this.props, 'getIsFetchingEmployee')
    const confirmType = get(this.props, 'confirmType')
    const confirmStatus = get(this.props, 'confirmStatus')
    const confirmMessage = get(this.props, 'confirmMessage')
    const IsSystemUser = get(this.props, 'authData.user.is_system_admin')
    const IsHRSubconUser = get(this.props, 'authData.user.is_hr_subcontract_role')

    const isAuthenticated = get(this.props, 'redirectAuth.isAuthenticated')
    || get(this.props, 'redirectSubcontractCost.isAuthenticated')
    const redirect = get(this.props, 'redirectAuth.redirect')
      || get(this.props, 'redirectSubcontractCost.redirect')
    if (redirect) {
      localStorage.clear()
      if (isAuthenticated) localStorage.setItem('bad_token', true)
      this.props.resetAuth()
      window.location = '/'
    }

    if (IsHRSubconUser !== undefined &&
      IsSystemUser !== undefined &&
      !(IsSystemUser || IsHRSubconUser)) window.location = '/home'
    return (
      /* eslint no-underscore-dangle: 0 */
      <Wrapper fluid>
        { isFetching &&
          <Overlay>
            <OverlayWrapper>
              <BeatLoader
                css={ css(`
                  position: absolute;
                  left: 50%;
                  top: 50%;
                `) }
                sizeUnit={ "px" }
                size={ 15 }
                color={ '#D44B49' }
                loading={ isFetching }
              />
            </OverlayWrapper>
          </Overlay>
        }
        <CustomModalMessage
          hide={ () => this.props.hideConfirm(confirmType) }
          show={
            confirmType === 'createCost'
            || confirmType === 'updateCost'
            || confirmType === 'discardCost'
          }
          type={ confirmStatus }
          message={ confirmMessage }
          button={ this.selectButton(confirmStatus, confirmType) }
        />
        <SearchBar
          subcontracts={ this.state.subcontracts }
          isEdit={ this.state.isEdit }
          handleClose={ this.handleClose }
          closeSpan={ () => this.setState({ isSpan: false, rowID: '' }) }
          handleSearch={ this.handleSearch }
          exportSubcontractCost={ () => this.props.exportSubcontractCost(localStorage.getItem('access_token')) }
          createSubcontractCost={ (payload) =>
            this.props.createSubcontractCost(payload, localStorage.getItem('access_token')) }
        />
        <Row noGutters>
          <Col>
            <SubcontractCostTable
              rowID={ this.state.rowID }
              subContractCosts={ this.filterSubcontract() }
              subcontracts={ this.state.subcontracts }
              clickRow={ this.clickRow }
            />
          </Col>
          { this.state.isSpan &&
            <Column>
              <EditSubcontractCost
                user={ this.state.user }
                cost={ this.state.cost }
                price={ this.state.price }
                start_date={ this.state.start_date }
                end_date={ this.state.end_date }
                isEdit={ this.state.isEdit }
                clickEdit={ this.clickEdit }
                handleEditInput={ this.handleEditInput }
                handleClose={ this.handleClose }
                editSubcontractCost={ this.editSubcontractCost }
              />
            </Column>
          }
        </Row>
      </Wrapper>
    )
  }
}

SubcontractCostPage.propTypes = {
  resetAuth: PropTypes.func.isRequired,
  showConfirm: PropTypes.func.isRequired,
  hideConfirm: PropTypes.func.isRequired,
  getAuth: PropTypes.func.isRequired,
  getEmployee: PropTypes.func.isRequired,
  getSubcontractCost: PropTypes.func.isRequired,
  createSubcontractCost: PropTypes.func.isRequired,
  exportSubcontractCost: PropTypes.func.isRequired,
  editSubcontractCost: PropTypes.func.isRequired,
}
const mapStateToProps = (state, props) => createStructuredSelector({
  modalStatus: modalSelector.modalStatus,
  modalType: modalSelector.modalType,
  modalMessage: modalSelector.modalMessage,
  confirmStatus: modalSelector.confirmStatus,
  confirmType: modalSelector.confirmType,
  confirmMessage: modalSelector.confirmMessage,
  authData: authSelector.getAuth,
  redirectAuth: authSelector.redirectAuth,
  redirectSubcontractCost: subcontractCostSelector.redirectSubcontractCost,
  getIsFetchingSubcon: subcontractCostSelector.getIsFetching,
  getIsFetchingEmployee: employeeSelector.getIsFetching,
  getEmployeeData: employeeSelector.getListUser,
  getSubcontractCostData: subcontractCostSelector.getSubcontractCostData,
  createSubcontractCostData: subcontractCostSelector.createSubcontractCostData,
  editSubcontractCostData: subcontractCostSelector.editSubcontractCostData,
  exportSubcontractCostData: subcontractCostSelector.exportSubcontractCostData,
})(state, props)
const mapDispatchToProps = dispatch => bindActionCreators({
  showModal: modalAction.showModal,
  hideModal: modalAction.hideModal,
  showConfirm: modalAction.showConfirm,
  hideConfirm: modalAction.hideConfirm,
  getAuth: authAction.auth,
  resetAuth: authAction.resetAuthUser,
  getEmployee: employeeAction.getUser,
  resetGetEmployee: employeeAction.resetListUser,
  getSubcontractCost: subcontractCostAction.getSubcontractCost,
  resetGetSubcontractCost: subcontractCostAction.resetGetSubcontractCost,
  createSubcontractCost: subcontractCostAction.createSubcontractCost,
  resetCreateSubcontractCost: subcontractCostAction.resetCreateSubcontractCost,
  editSubcontractCost: subcontractCostAction.editSubcontractCost,
  resetEditSubcontractCost: subcontractCostAction.resetEditSubcontractCost,
  exportSubcontractCost: subcontractCostAction.exportSubcontractCost,
  resetExportSubcontractCost: subcontractCostAction.resetExportSubcontractCost,
}, dispatch)
export default connect(mapStateToProps, mapDispatchToProps)(withLayout(SubcontractCostPage))

const Wrapper = styled(Container)`
  padding: 0px;
`
const Column = styled(Col)`
  padding-left: 0px;
  padding-right: 0px;
`
const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 1;
`
const OverlayWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`



// WEBPACK FOOTER //
// ./src/pages/subcontract-cost/index.js